var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41667 27.625C1.41655 25.3796 2.06437 23.1819 3.28238 21.2957C4.5004 19.4094 6.23686 17.9146 8.28338 16.9909C10.3299 16.0671 12.5995 15.7534 14.8199 16.0877C17.0402 16.4219 19.1169 17.3897 20.8008 18.875M21.8333 24.7083L24.75 27.625L30.5833 21.7917M20.375 8.66667C20.375 12.6937 17.1104 15.9583 13.0833 15.9583C9.05626 15.9583 5.79167 12.6937 5.79167 8.66667C5.79167 4.63959 9.05626 1.375 13.0833 1.375C17.1104 1.375 20.375 4.63959 20.375 8.66667Z",
    stroke: "#0071E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/vector-3.8befb698c0b4ebeccccef04cd8d3efc8.svg";
export { ForwardRef as ReactComponent };